import {createStyles, Theme} from "@material-ui/core";
import {beigeColor, buttonContained, primaryColor, secondaryColor, styleColors} from "src/main.style";

export const CalendarFABStyle = (theme: Theme) => createStyles({
  buttonContained,
  bottomPaper : {
    borderRadius: '10px 10px 0px 0px',
    width: '100%',
    margin: 'auto 0px 0px 0px',
    border: `1px solid ${styleColors.greyMedium1}`,
    borderBottom: `0px solid ${styleColors.greyMedium1}`,
  },
  FAB : {
    color: '#FFFFFF',
    width: '62px',
    cursor: 'pointer',
    height: '62px',
    display: 'flex',
    overflow: 'hidden',
    fontSize: '24px',
    boxSizing: 'border-box',
    transition: 'all 0.2s',
    alignItems: 'center',
    userSelect: 'none',
    borderRadius: '50%',
    justifyContent: 'center',
    boxShadow: `0px 3px 30px ${styleColors.fabShadow}`,
    backgroundColor: primaryColor,
    webkitUserSelect: 'none',
    position: 'absolute',
    bottom: '100px',
    right: '20px',
    zIndex: 100,
  },
  FABcontent : {
    backgroundColor: secondaryColor,
    maxWidth: '50px',
    minWidth: '50px',
    minHeight: '50px',
    maxHeight: '50px',
    borderRadius: '100px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  today : {
    bottom: '182px',
    boxShadow: `0px 3px 30px ${styleColors.fabShadow}`,
    backgroundColor: secondaryColor,
    fontSize: '12px;',
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
  activity : {
    bottom: '90px',
    boxShadow: `0px 3px 30px ${styleColors.fabShadow}`,
    backgroundColor: primaryColor,
    fontSize: '12px;',
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
  change : {
    bottom: '182px',
    boxShadow: `0px 3px 30px ${styleColors.fabShadow}`,
    backgroundColor: secondaryColor,
    fontSize: '12px;',
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    textAlign: 'center',
    wordBreak: 'break-word',
  },
  aiText : {
    fontSize: '16px',
    fontWeight: 500,
  },
  aiWaitBackground :  {
    backgroundColor: secondaryColor,
  },
  aiFailedBackground : {
    backgroundColor: primaryColor,
  },
  aiReadyBackground : {
    background: `linear-gradient(60deg,${styleColors.rainbowBlue},${styleColors.rainbowViolet},${styleColors.rainbowMagenta},${styleColors.coralRed},${styleColors.rainbowOrange},${styleColors.rainbowLime},${styleColors.rainbowGreen},${styleColors.rainbowCyan})`,
    backgroundSize: '186px 186px',
    animation: `$moveGradient 4s alternate infinite`,
    boxShadow: '0px 3px 30px '+secondaryColor+'ad',
  },
  '@keyframes moveGradient' : {
    '50%':{
      backgroundPosition: '-124px -124px',
    }
  },
  aiAnalyzingBackground : {
    background: `conic-gradient(from 90deg at 50% 50%, ${styleColors.greyDark1}, ${styleColors.white}, ${styleColors.greyDark1}, ${styleColors.white}, ${styleColors.greyDark1})`,
    animation: `$rotateGradient 2s infinite linear`,
    boxShadow: '0px 3px 30px '+secondaryColor+'ad',
    backgroundSize: '124px 124px',
  },
  '@keyframes rotateGradient' : {
    '0%' :{
      backgroundPosition: '0px 0px',
    },
   '50%': {
      backgroundPosition: '62px 62px',
    },
    '100%' : {
      backgroundPosition: '0px 0px',
    }
  },
  aiSelectFAB : {
    minWidth: 'auto',
    width: 'auto',
    maxWidth: '140px',
    borderRadius: '16px',
    alignItems: 'flex-start',
    padding: '8px',
    maxHeight: '200px',
    height: 'auto',
  },
  aiSelectInner : {
    minWidth: '10px',
    maxWidth: '200px',
    alignItems: 'flex-start',
    maxHeight: '120px',
    height: 'auto',
    gap: '8px',
  },
  aiSelectButton : {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px',
  },
  fullscreenPaper : {
    alignSelf: 'flex-start',
    margin: '0px',
    width:'min(100vw,600px)',
    minWidth:'min(100vw,600px)',
    maxWidth:'min(100vw,600px)',
    height:'100vh',
    maxHeight:'100vh',
    minHeight:'100vh',
    overflow:'auto'
  },
  background: {
    boxSizing: 'content-box',
    position: 'fixed',
    overflow: 'hidden',
    top: 0,
    left: 0,
    width: '100vw',
    minWidth: '100vw',
    maxWidth: '100vw',
    height: '100vh',
    minHeight: '100vh',
    maxHeight: '100vh',
    // zIndex: 0,
    backgroundColor: theme.palette.background.default,
  },
  circle: {
    // zIndex: 1,
    position: 'absolute',
    top: '20rem',
    left: '-1.75rem',
    width: '56.25rem',
    height: '56.25rem',
    borderRadius: '56.25rem',
    backgroundColor: beigeColor,
},

});




// WEBPACK FOOTER //
// ./src/components/calendar2/fab/CalendarFAB.style.ts